export default "__VITE_ASSET__06f1f881__"